module.exports = __webpack_public_path__ + "img/大暴雨-特大暴雨.0837bc32.png";